export type Params = {
  orgId: string,
  dishId: number, //id продукции
}

export type PostParams = {
  orgId: string,
  dishId: number,
  settings: {
    disableForTerminalGuestSales: boolean
  }
}

export type AdditionalSettingsType = {
  disableForTerminalGuestSales: boolean
}

export const isParamsValid = (params: Partial<Params>): params is Params => {
  const { orgId, dishId } = params
  if (orgId && dishId) {
    return true
  }
  return false
}
